import { invoiceRows } from '@biuro/shared';
import { ApiError } from './api.ts';
import { closeStatus, defaultCloseMonth } from './close.ts';
import { TABS, useData, useMe, useNav, useSettings, type Tab } from './hooks.tsx';
import { Brand, Icon } from './ui.tsx';
import { useFileDropGuard } from './FileDrop.tsx';
import { Faktury } from './views/Uslugi.tsx';
import { Firma } from './views/Firma.tsx';
import { Miesiac } from './views/Miesiac.tsx';
import { Pulpit } from './views/Pulpit.tsx';
import { Terminy } from './views/Terminy.tsx';

const VIEWS = { pulpit: Pulpit, terminy: Terminy, faktury: Faktury, miesiac: Miesiac, firma: Firma };

/** Liczniki przy zakładkach: szkice faktur z Gmaila i otwarte kroki zamknięcia miesiąca. */
function useBadges(): Partial<Record<Tab, number>> {
  const { data } = useData();
  const st = useSettings();
  const drafts = invoiceRows(data).filter((x) => x.c.draft).length;
  const open = closeStatus(data, st, defaultCloseMonth()).steps.filter((s) => s.state === 'todo' || s.state === 'late').length;
  return { faktury: drafts, miesiac: open };
}

function Nav({ short }: { short?: boolean }) {
  const { tab, go } = useNav();
  const badges = useBadges();
  return (
    <>
      {TABS.map((t) => {
        const I = Icon[t.key];
        const n = badges[t.key];
        return (
          <button key={t.key} className="nav-btn" aria-current={tab === t.key ? 'page' : undefined} onClick={() => go(t.key)}>
            <I />
            <span>{short ? t.short : t.label}</span>
            {n ? <span className="badge" aria-label={`${n} do zrobienia`}>{n}</span> : null}
          </button>
        );
      })}
    </>
  );
}

function Login() {
  const err = new URLSearchParams(location.search).get('blad');
  return (
    <main className="login">
      <div className="login-card">
        <Brand />
        <h1>Zaloguj się do Biura</h1>
        <p>Terminy podatkowe, faktury zagraniczne z odwrotnym obciążeniem, dokumenty w inFakcie i paczka dla biura rachunkowego.</p>
        {err && <div className="note bad">{err}</div>}
        <a className="btn pri" href="/auth/login">Zaloguj się przez Google</a>
      </div>
    </main>
  );
}

export function App() {
  const me = useMe();
  const { tab } = useNav();
  useFileDropGuard();
  if (me.isLoading) return <main className="login"><span className="spin" aria-label="Ładowanie" /></main>;
  if (me.error instanceof ApiError && me.error.status === 401) return <Login />;
  if (me.error) {
    return (
      <main className="login">
        <div className="login-card"><div className="note bad">{(me.error as Error).message}</div><button className="btn" onClick={() => me.refetch()}>Spróbuj ponownie</button></div>
      </main>
    );
  }
  const View = VIEWS[tab];
  const g = me.data?.google;
  const connected = !!(g?.drive && g?.calendar && g?.gmail);
  return (
    <>
      <div className="shell">
        <nav className="side" aria-label="Sekcje">
          <Brand />
          <Nav />
          <div className="side-foot">
            <span className="conn"><i className={connected ? 'on' : ''} />{connected ? 'Google połączony' : 'Google niepołączony'}</span>
            <span className="conn"><i className={me.data?.infakt.enabled ? 'on' : ''} />{me.data?.infakt.enabled ? 'inFakt połączony' : 'inFakt niepołączony'}</span>
            <span>{me.data?.email}</span>
          </div>
        </nav>
        <main className="main">
          <div className="m-head"><Brand /></div>
          <View />
        </main>
      </div>
      <nav className="tabbar" aria-label="Sekcje"><Nav short /></nav>
    </>
  );
}
